import { Brand } from '../branded-types';
import { IEfaToFareVia } from './efa-to-fare.interfaces';

export type LatitudeCoordinate = Brand<number, 'latCoord'>;
export type LongitudeCoordinate = Brand<number, 'longCoord'>;

export type JourneyLocationId = Brand<string, 'locationIdentifier'>;

export enum EJourneyPlanningProviderName {
  Hafas = 'hafas',
  Pis = 'pis',
  Trias = 'trias',
}

export interface IJourneyStop {
  id: string;
  externalId: string;
  name: string;
  longitudeCoord: LongitudeCoordinate;
  latitudeCoord: LatitudeCoordinate;
  timezoneOffset: number;
  weight: number;
}

export interface IJourneyOperator {
  id: string;
  name: string;
  url: string;
}

export interface IJourneyProduct {
  operator: IJourneyOperator;
}

export interface IJourneyTrip {
  id: string;
  origin: IJourneyLocation;
  destination: IJourneyLocation;
  legs: IJourneyLeg[];
  tariffSegments?: IEfaToFareVia[];
}

export interface IJourneyLocation {
  id: JourneyLocationId;
  locationReferenceId: string;
  externalId: string;
  name: string;
  type: string;
  longitudeCoord: LongitudeCoordinate;
  latitudeCoord: LatitudeCoordinate;
  time: string;
  date: string;
}

export interface IJourneyLeg {
  id: string;
  name: string;
  direction: string;
  type: string;
  distance: number;
  operator: IJourneyOperator;
  origin: IJourneyLocation;
  destination: IJourneyLocation;
}

export interface IJourneyBoard {
  name: string;
  stop: string;
  type: string;
  stopId: string;
  externalStopId: string;
  longitudeCoord: LongitudeCoordinate;
  latitudeCoord: LatitudeCoordinate;
  time: string;
  date: string;
  track: string;
  direction: string;
  products: IJourneyProduct[];
}
